import type { DeclarativePerson } from "../flow/types";

export function isDeclarativePersonValid(data: DeclarativePerson | undefined | null) {
  if (!data) return false;
  return !!data.firstnames?.trim() && !!data.lastnames?.trim() && !!data.gender;
}
